import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";
import "../../scss/help.scss";

function initFAQLinks() {
  document.querySelectorAll(".js-faq-expand").forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const target = event.currentTarget as HTMLElement | null;
      if (!target) return;
      target.classList.toggle("Help__FAQ__Title--expanded");
      target.nextElementSibling?.classList.toggle("d-block");
    });
  });
}

function initScript(resourceUrl: string) {
  if (!resourceUrl) return;
  const script = document.createElement("script");
  script.src = resourceUrl;
  script.type =
    resourceUrl.indexOf("/es5/") > -1 ? "text/javascript" : "module";
  document.body.appendChild(script);
}

function initStyleLink(resourceUrl: string) {
  if (!resourceUrl) return;
  const tag = document.createElement("link");
  tag.href = resourceUrl;
  tag.type = "text/css";
  tag.rel = "stylesheet";
  document.body.appendChild(tag);
}

function initHelpCentre() {
  if (window.helpCentreJsUrls) {
    window.helpCentreJsUrls.forEach((jsUrl) => initScript(jsUrl));
  }
  if (window.helpCentreCssUrls) {
    window.helpCentreCssUrls.forEach((cssUrl) => initStyleLink(cssUrl));
  }
}

async function initHelpPage() {
  await initTranslation();
  initPage();
  initFAQLinks();
  initHelpCentre();
}

initHelpPage();
